import { render, staticRenderFns } from "./VideoSessionPanel.vue?vue&type=template&id=15b3580b&scoped=true&"
import script from "./VideoSessionPanel.vue?vue&type=script&lang=js&"
export * from "./VideoSessionPanel.vue?vue&type=script&lang=js&"
import style0 from "./VideoSessionPanel.vue?vue&type=style&index=0&id=15b3580b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b3580b",
  null
  
)

export default component.exports